var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"current-user-nav"},[_c('ul',[_c('li',{staticClass:"current-user"},[_c('router-link',{attrs:{"to":{
          name: 'user',
          params: {
            userId: _vm.currentUser.id
          }
        }}},[_vm._v("\n        "+_vm._s(_vm.displayName)+"\n      ")])],1),_vm._v(" "),_c('li',{staticClass:"logout"},[_c('router-link',{attrs:{"to":{ name: 'sign_out' }}},[_vm._v("\n        Logout\n      ")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16caabbb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CurrentUserNav.vue
// module id = 1143
// module chunks = 1